<template>
  <sidebar>
    <form ref="showSearchForm" @submit.prevent>
      <item-sidebar-links :item="item" :show="show" :link-name="linkName" />
      <item-external-source
        v-if="item.name || shouldOpenSidebar === false"
        :show-images="item.images"
        :languageId="languageId"
        :value="item.name"
        ref="itemExternalSource"
        @moveToAll="$emit('moveAllExternalDataToShow', $event)"
        @moveToEmpty="$emit('moveExternalDataToShowEmptyFields', $event)"
        @imagesChanged="$emit('imagesChanged', $event)"
      />
      <item-original-source v-if="epgDetails" :item="item" @submit="$emit('moveOriginal', $event)" />
    </form>
  </sidebar>
</template>

<script>
import Sidebar from '../Common/Sidebar/Sidebar'
import SidebarItem from '../Common/Sidebar/SidebarItem'
import ItemSidebarLinks from './ItemSidebarLinks'
import ItemExternalSource from './ItemExternalSource'
import ItemOriginalSource from './ItemOriginalSource'
import ItemMoveEverything from './ItemMoveEverything'
import ItemCheckboxInput from './ItemCheckboxInput'

export default {
  name: 'main-sidebar',
  components: {
    ItemCheckboxInput,
    ItemMoveEverything,
    ItemExternalSource,
    ItemOriginalSource,
    ItemSidebarLinks,
    Sidebar,
    SidebarItem
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    show: {
      type: Object,
      default: null
    },
    linkName: {
      type: String,
      default: null
    },
    epgDetails: {
      type: Boolean,
      default: false
    },
    shouldOpenSidebar: {
      type: Boolean,
      default: false
    },
    languageId: {
      type: Number,
      default: 0.0
    },
    selectedLanguageId: {
      type: Number,
      default: 0
    }
  },
  methods: {
    onShowSelected(id) {
      this.$emit('showSelected', id)
    }
  }
}
</script>
